module.exports = __webpack_public_path__ + "img/rolling10_icon.7fb05b49.png";